module.exports = __webpack_public_path__ + "img/20200515_160132.91454761.jpg";